/*
 * Registers the Guide dock with Backstage's new frontend system.
 *
 * `AppRootElementBlueprint` renders an element at the app root, outside the app layout — which
 * is what a docked panel that persists across every route needs. It is a documented extension
 * point in `@backstage/frontend-plugin-api`; no upstream source is modified, and the scaffolded
 * app gains one import.
 *
 * The module declares `pluginId: 'app'` to match the shape the theme module and the scaffolded
 * nav module already use.
 */
import { AppRootElementBlueprint, createFrontendModule } from '@backstage/frontend-plugin-api';
import { GuideWidget } from './GuideWidget';
import './GuideWidget.css';

const guideDock = AppRootElementBlueprint.make({
  name: 'stackschematic-guide',
  params: { element: <GuideWidget /> },
});

export const stackSchematicGuideModule = createFrontendModule({
  pluginId: 'app',
  extensions: [guideDock],
});
